import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";
import { NOTIFICATION_CATEGORIES, NotificationCategorySchema } from "./create";

/** Préférence par catégorie × canal. Défauts : inApp+push activés, email désactivé. */
export const notificationPreferenceSchema = z.object({
  id: z.string(),
  userId: z.string(),
  category: NotificationCategorySchema,
  inApp: z.boolean().default(true),
  push: z.boolean().default(true),
  email: z.boolean().default(false),
});

export class NotificationPreferenceDto extends createZodDto(notificationPreferenceSchema) {}

/** Mise à jour d'une préférence (PUT /notifications/preferences/:category) */
export const updateNotificationPreferenceSchema = z.object({
  inApp: z.boolean().optional(),
  push: z.boolean().optional(),
  email: z.boolean().optional(),
});
export class UpdateNotificationPreferenceDto extends createZodDto(
  updateNotificationPreferenceSchema,
) {}

/** Listing complet des préférences (une entrée par catégorie, défauts à la volée). */
export const notificationPreferencesSchema = z.object({
  preferences: z.array(notificationPreferenceSchema),
});
export class NotificationPreferencesDto extends createZodDto(notificationPreferencesSchema) {}
